const getStatusPageSummary = () => {
  return getDataByType("summary").then((data) => data);
};

const getStatusPageIncidents = () => {
  return getDataByType("incidents").then((data) => data);
};

const getDataByType = (type) => {
  return getStatusPage().then((statusPage) => {
    return new Promise((resolve) => {
      statusPage[type]({
        success: (data) => {
          resolve(data);
        },
      });
    });
  });
};

const hasScript = () => {
  return Array.from(document.getElementsByTagName("script")).some((script) =>
    script.src.includes("cdn.statuspage.io")
  );
};

const loadScript = (callback) => {
  const script = document.createElement("script");
  script.async = true;
  script.defer = false;
  script.onload = callback;
  script.nonce = process.env.VUE_APP_GTM_NONCE;
  script.src = "https://cdn.statuspage.io/se-v2.js";

  document.body.appendChild(script);
};

const newStatusPage = () => {
  return new StatusPage.page({ page: process.env.VUE_APP_STATUSPAGE_ID });
};

const getStatusPage = async () => {
  if (!process.env.VUE_APP_STATUSPAGE_ID) {
    return null;
  }

  if (!hasScript()) {
    return new Promise((resolve) => {
      loadScript(() => {
        resolve(newStatusPage());
      });
    });
  }

  return newStatusPage();
};

export { getStatusPageSummary, getStatusPageIncidents };
